import { ConfigServiceApi, Configuration } from '@ennismore/config-client';

import { axios } from '@/api/axios-instance';
import { ResponseValidationError } from '@/api/errors/api-response-validation.error';
import { getClientHeaders } from '@/api/headers';
import { buildBaseUrl } from '@/api/helpers/build-base-url';
import { EnnismoreAPIClientConfig } from '@/api/interfaces';

import { HotelConfiguration, HotelConfigurationModel } from '../models';

/**
 * Client for em-config/CMS
 */
export class ConfigServiceClient {
  protected client: ConfigServiceApi;

  protected get options() {
    return {
      headers: {
        'x-api-key': this.credentials.apiKey,
        'x-skip-redirect': this.credentials.skipRedirect,
        ...getClientHeaders(this.credentials),
      },
    };
  }

  constructor(private readonly credentials: EnnismoreAPIClientConfig) {
    const baseUrlWithoutV2 = credentials.baseUrl.replace('/v2', '');

    const config = new Configuration({
      basePath: buildBaseUrl(baseUrlWithoutV2, {
        servicePrefix: 'config',
      }),
      apiKey: credentials.apiKey,
    });

    this.client = new ConfigServiceApi(config, undefined, axios);
  }

  /**
   * Fetch an extended hotel configuration, sourced from the platform CMS.
   * @param hotelReferenceId
   * @param locale
   * @returns Extended hotel configuration
   */
  async getHotelConfig({
    hotelReferenceId,
    locale,
  }: {
    hotelReferenceId: string;
    locale: string;
  }): Promise<HotelConfiguration> {
    const response = await this.client.configServiceGetHotel(
      locale,
      {
        hotelReferenceId,
      },
      this.options
    );

    const hotel = HotelConfigurationModel.safeParse(response.data);

    if (!hotel.success) {
      throw new ResponseValidationError(hotel.error);
    }

    return hotel.data;
  }
}
